// ✅ ServicesPage.js - Modal支援多課程項目版
import React, { useRef, useState, useEffect } from 'react';
import '../SpaSite.css'; // 假設 SpaSite.css 存在於上一層目錄

const courseData = [
  {
    id: 4,
    img: 'c4.jpg', // 大類代表圖
    title: '胞泌體-再昇修復',
    desc: 'EXOSOME CARE',
    content: '甄選韓國優質原裝進口植物胞泌體產品，美國FDA、MoCRA 嚴格規範，並與歐盟市場同步，經CPNP化妝品規範/安全登錄，是頭髮再昇、頂級臉部課程最佳選擇。透過先進的胞泌體技術，深入修護，煥發細胞活力，保持緊實彈嫩。',
    price: 'NT$2,980 起',
    details: [ // 細分課程項目
      {
        subId: 'exo_hair_01',
        subTitle: '胞泌體臉部煥膚護理 Exosome Facial Care',
        subImage: 't1.jpg', // 假設的細分課程圖片
        subDescription: '純淨高濃縮精萃安瓶搭配隱形注氧水波光，修護受損肌膚屏障，喚醒基底的原生美麗',
        subPrice: '70分鐘 NT$2,980起',
        subFeatures: ['適合族群：肌膚吸收力不佳、毛孔粗大暗沉、敏弱肌膚']
      },
      {
        subId: 'exo_face_01',
        subTitle: '胞泌體頭部再昇蘊髮 Exosome Hair Restoration',
        subImage: 't2.jpg',
        subDescription: `
        稀疏髮專屬，搭配高濃度純淨外秘體蘊髮精華，提供脆弱的毛髮與頭皮，最根本純淨的修護喚醒豐盈生機！
        `,
        subPrice: '90分鐘 體驗價 NT$6,600',
        subFeatures: ['本課程有包含洗髮', '適合族群：毛髮脆弱、稀疏、落髮困擾']
      }
    ],
  },
  {
    id: 2,
    img: 'c1.jpg', // 大類代表圖
    title: '身體護理',
    desc: 'BODY MASSAGE',
    content: '透過專業按摩師的深層肌肉放鬆與淋巴引流手技，結合高品質芳香精油，啟動身體的自我修復機制，讓身心恢復平衡與穩定。',
    price: 'NT$1,280 起',
    details: [
      {
        subId: 'body_swedish_01',
        subTitle: '脈輪淨化平衡按摩 Body Energy Balancing Massage',
        subImage: 'body1.jpg', // 假設的細分課程圖片
        subDescription: '透過精油深層調理，融合經絡學，結合東方釋壓手法放鬆組織，施予全身深層肌肉按摩。同時運用芳香療法進行能量調息，紓解全身緊繃',
        subPrice: '60+20分鐘 體驗價 NT$1,880 ',
        subFeatures: ['含60分鐘手技與20分鐘活化護理', '適合族群：壓力大、失眠者',]


      },
      {
        subId: 'body_swedish_01',
        subTitle: '處方油深層按摩 Customized Essential Oil Deep Massage',
        subImage: 'model1.jpg', // 假設的細分課程圖片
        subDescription: '客製處方精油，有效迅速緩解身體不適，與長久累積疲勞，讓身體肌肉更容易進入放鬆狀態',
        subPrice: '90分鐘 體驗價 NT$2,800 ',
        subFeatures: ['適合族群：長期肌肉痠痛僵硬者']

      },
      {
        subId: 'body_hotstone_03',
        subTitle: '深呼吸美胸療程 Lymphatic Care – Chest Area',
        subImage: 'body6.jpg',
        subDescription: '理療精油搭配中式筋膜手法，加強心肺區及腋下淋巴疏通，使胸腔行氣呼吸順暢。',
        subPrice: '60分鐘 體驗價 NT$1,880',
        subFeatures: ['含40分鐘手技與20分鐘活化護理', '孕媽咪不宜適用']
      },
      {
        subId: 'body_hotstone_03',
        subTitle: '腹腔能量循環護理 Stomach Meridian Massage',
        subImage: 'body7.jpg',
        subDescription: '長期久坐或緊張壓力，讓腹部成為身體沉重的區域。獨家引流手法結合薑根腹部溫敷，溫柔釋放腹部深層緊繃與壓力，帶來輕盈舒適的放鬆感',
        subPrice: '60分鐘 體驗價 NT$1,880',
        subFeatures: ['含40分鐘深層手技＋20分鐘舒緩熱療護理', '孕媽咪不宜適用']
      },
      {
        subId: 'body_hotstone_03',
        subTitle: '八療暖宮療程 Womb Harmony Massage',
        subImage: 'body8.jpg',
        subDescription: '暖宮穴位疏通手法，帶動上下經絡活絡，平衡氣血，促進女性機能活悅分泌，滋養潤澤回春。',
        subPrice: '60分鐘 體驗價 NT$1,880',
        subFeatures: ['含40分鐘手技與20分鐘活化護理', '孕媽咪不宜適用']
      },
      {
        subId: 'body_swedish_01',
        subTitle: '背部釋壓舒緩療程 Deep Back Comfort Massage',
        subImage: 'body3.jpg', // 假設的細分課程圖片
        subDescription: '為肩頸緊繃設計的速效深層放鬆',
        subPrice: '40分鐘 體驗價 NT$1,280 ',

      },
      {
        subId: 'body_swedish_01',
        subTitle: '舒活美腿油壓 Revitalizing Leg Oil Massage',
        subImage: 'body5.jpg', // 假設的細分課程圖片
        subDescription: '紓解久站久坐的沉重腫脹',
        subPrice: '40分鐘 體驗價 NT$1,280 ',

      },
    ],
  },
  {
    id: 1,
    img: 'c2.jpg', // 大類代表圖
    title: '臉部護理',
    desc: 'FACIAL CARE',
    content: '我們的臉部護理課程針對不同膚質與需求設計，採用頂級護膚產品結合專業手技與儀器，清潔、保濕、修復，改善肌膚問題，重拾光滑嫩白。',
    price: 'NT$1,500 起',
    details: [
      {
        subId: 'face_360_01',
        subTitle: '韓式水淨肌 Korean Aqua Facial',
        subImage: 'face4.png', // 假設的細分課程圖片
        subDescription: `呵護肌膚，從專業皮膚管理開始！透過清潔、保濕、修復，改善肌膚問題，重拾光滑嫩白，讓你散發自信與美麗~`,
        subPrice: '50分鐘 體驗價 NT$1,200',
        subFeatures:
          [`推薦加購：`,

            `手工清粉刺 20min $300`,

            `安瓶導入(保濕/提拉) $800~$1200`,

            `頭肩頸紓壓按摩 20min $500`,

            `耳燭淨化舒活護理 30min $800`,

          ]

      },
      {
        subId: 'face_sensitive_03',
        subTitle: `日式撥筋小顏護理 Japanese Facial Sculpting Massage`,
        subImage: 'face3.jpg',
        subDescription: '卸妝清潔~深層淨膚~角質潔淨~臉部筋膜撥筋~頭部經絡喚醒~香氛整肌面膜鎮定~粉刺處理~面膜養護~調理防護',
        subPrice: '90分鐘 體驗價 NT$2,100',
        subFeatures: ['舒緩眼睛疲勞酸澀、眼壓高、黑眼圈', '改善肌膚暗沉、水腫', '改善臉部輪廓線條']
      },
      {
        subId: 'face_360_01',
        subTitle: '360極速拉提臉部護理 Instant V-Lift Facial',
        subImage: 'face1.jpg', // 假設的細分課程圖片
        subDescription: '獨家法式特殊三重奏手法，透過深層揉，有效舒緩緊繃，搭配新一代抗齡胜肽精華，在揉捏提拉筋膜放鬆中深層滲透，臉頰自然澎潤，讓肌膚綻放緊緻光彩、重現年輕輪廓',
        subPrice: '100分鐘 體驗價 NT$2,450',
      },
      {
        subId: 'face_360_01',
        subTitle: '玻尿酸超導護理 Deep Hydration Facial with Hyaluronic Acid',
        subImage: 'face7.png', // 假設的細分課程圖片
        subDescription: '全程使用西班牙進口保養套組玻尿酸超導科技,築起皮膚水脂膜,多層精華強化滲透吸收，四步驟階段遞增肌膚水分儲量和活水循環，促進玻尿酸及硫酸軟骨素合成',
        subPrice: '100分鐘 歡迎店洽',
        subFeatures: ['一次解決六大肌膚困擾：乾燥、細紋、暗沉、粗糙、鬆弛、無光', '針對缺水毛孔粗大、季節性乾燥、醫美術後肌推薦']

      },
      {
        subId: 'face_360_01',
        subTitle: '光澤高效勻白護理 Luminous C+ Advanced Brightening Facial',
        subImage: 'face5.png', // 假設的細分課程圖片
        subDescription: '全程使用西班牙進口保養套組，擁有4種維生素C+紅石榴+巴西莓，針對膚色不均、暗沉蠟黃肌、日光性老化,高濃度4種活性因子,植物成分,即效淨斑,集中淡化暗沉',
        subPrice: '100分鐘 歡迎店洽',
        subFeatures: ['超C+活性因子發揮3倍肌膚穿透力', '提高700%以上的細胞吸收度', '讓肌膚回歸光透潤白']
      },
      {
        subId: 'face_360_01',
        subTitle: '抗皺膠原緊緻護理 Collagen Firming & Anti-Wrinkle Facial',
        subImage: 'face6.png', // 假設的細分課程圖片
        subDescription: '進階抗老護理課程，全程使用歐洲進口頂級沙龍保養品，以高濃度膠原蛋白活性精華＋RF深層提拉儀器為核心，針對鬆弛、細紋、法令紋、輪廓模糊問題，全方位重建肌膚支撐力有感緊致澎潤Q彈',
        subPrice: '100分鐘 歡迎店洽',

      },
      {
        subId: 'face_360_01',
        subTitle: '集水保濕護理 Aqua Balance Hydration Facial',
        subImage: 'face8.png', // 假設的細分課程圖片
        subDescription: '專為缺水肌膚設計，淨化疲憊暗沉肌膚,重建肌膚的保水屏障，迅速提高肌膚保水度,使肌膚柔嫩、水亮、有彈性',
        subPrice: '80分鐘 體驗價 NT$1,880',
      },


    ],
  },
  {
    id: 3,
    img: 'c3.jpg', // 大類代表圖
    title: '體態管理',
    desc: 'SLIM & RELAX',
    content: '結合專業手技與先進科技體雕儀器，為您量身打造專屬的體態管理方案。無論是局部雕塑、緊實肌膚或深層放鬆，都能助您輕盈地擁抱更美好的自己。',
    price: 'NT$ 990 起',
    details: [
      {
        subId: 'slim_g5_01',
        subTitle: '法國智能體雕 LPG Lipomassage',
        subImage: 's1.jpg',
        subDescription: '法國專利智能科技，多種不同組合的深層體雕揉捏模組，專利技術揉捏拍打，有效塑形，改善水腫，促進脂肪代謝與肌膚緊緻。',
        subPrice: '30分鐘 體驗價 NT$1,980',
        subFeatures: ['適合族群：水腫循環不佳、產後瘦身、醫美術後']
      },
      {
        subId: 'slim_rf_02',
        subTitle: '芭比炫腹動磁波護理 Emsculpt Body Sculpting',
        subImage: 's2.jpg',
        subDescription: '運用高強度動磁波，每30分鐘肌肉收縮鍛鍊達兩萬次，輕鬆享受被動式緊緻線條。',
        subPrice: '30分鐘 體驗價 NT$990',
        subFeatures: ['適合族群：欲鍛鍊肌肉者、想偷懶瘦身的你']
      },
      {
        subId: 'slim_g5_03',
        subTitle: '負壓緊緻護理 RF Slimming Beauty Device',
        subImage: 's3.jpg',
        subDescription: '負壓 + 熱能深層模式進行吸力按摩，疏通長期累積淤塞，幫助細胞組織營養與氧氣帶入肌膚底層，有效促進血液流動，提高身體循環。',
        subPrice: '30分鐘 體驗價 NT$1,980',
        subFeatures: ['適合族群：水腫循環不佳、產後瘦身、醫美術後']
      },
    ],
  },
  {
    id: 5,
    img: 'model2.jpg', // 大類代表圖
    title: '頭部護理',
    desc: 'HEAD CARE',
    content: '舒壓～從頭開始，釋放腦壓與疲憊，喚醒身心能量。針對壓力頭皮，進行深層舒壓護理，解鎖頭部壓力，喚醒身心能量。',
    price: 'NT$1,380 起',
    details: [ // 細分課程項目
      {
        subId: 'body_lymphatic_02',
        subTitle: '耳燭淨化舒活護理 Ear Candling',
        subImage: 'body2.jpg',
        subDescription: '採用義大利嚴選理療精油，放鬆前胸淋巴,頭肩壓力，再藉由耳燭燃燒時產生的微熱力，舒適淋巴引流手法，把耳道的溼氣排除，同時帶動頭部循環，有效緩解頭部腫脹，臉部水腫。',
        subPrice: '45分鐘 體驗價 NT$1,380',
        subFeatures: ['適合族群：腦部壓力大、失眠、思慮過多']
      },
      {
        subId: 'face_antiaging_02',
        subTitle: '頭皮淨化調理 Classic Scalp Care',
        subImage: 'head.jpg',
        subDescription: '透過頭皮放鬆、角質淨化 深度調理頭皮環境。',
        subPrice: '60分鐘 體驗價 NT$2,000',
        subFeatures: ['流程：AI頭皮智能檢測～精油靜心舒緩～頭肩頸解壓～頭皮角質淨化～頭皮清潔洗髮～保濕調理']
      },
      {
        subId: 'body_lymphatic_02',
        subTitle: '頭部減壓護理 Head Relaxing Massage',
        subImage: 'model2.jpg',
        subDescription: '結合義大利香氛精油嗅吸舒緩，搭配眼部與頭部降壓刮梳，透過循序漸進的按摩手法，溫柔釋放頭皮緊繃與腦壓，舒緩長時間用眼與高壓狀態，幫助身心回到平衡節奏。',
        subPrice: '40分鐘 體驗價 NT$1,280',
        subFeatures: ['適合族群：腦部壓力大、失眠、思慮過多']
      },
    ],
  },
];

const colors = {
  primary: '#1a1a1a',
  secondary: '#4c956c',
  accent: '#d9f2b4',
  light: '#f8faf5',
  neutral: '#336F4D',
  neutralLight: '#505151',
  cream: '#fffaf0',
  gold: '#d4af37',
  textDark: '#333'
};

export default function ServicesPage() {
  const coursesContainerRef = useRef(null);

  const [canScrollRight, setCanScrollRight] = useState(true);
  const [currentPage, setCurrentPage] = useState(0);
  const [animatedElements, setAnimatedElements] = useState({});
  const [selectedService, setSelectedService] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const cardsPerView = 3;

  const handleNextClick = () => {
    const totalPages = Math.ceil(courseData.length / cardsPerView);
    const nextPage = Math.min(currentPage + 1, totalPages - 1);
    scrollToPage(nextPage);
  };

  const handlePrevClick = () => {
    const prevPage = Math.max(currentPage - 1, 0);
    scrollToPage(prevPage);
  };

  const scrollToPage = (pageIndex) => {
    const container = coursesContainerRef.current;
    if (!container) return;
    const cardWidth = container.children[0] ? container.children[0].offsetWidth : 280;
    const cardMargin = 10;
    const totalCardWidth = cardWidth + (cardMargin * 2);
    let scrollTo;
    if (cardsPerView >= courseData.length) {
      scrollTo = 0;
    } else {
      const firstCardIndexOfPage = pageIndex * cardsPerView;
      const maxScrollLeft = container.scrollWidth - container.clientWidth;
      scrollTo = Math.min(firstCardIndexOfPage * totalCardWidth, maxScrollLeft);
    }
    container.scrollTo({ left: scrollTo, behavior: 'smooth' });
    setCurrentPage(pageIndex);
  };

  const handleCourseDetail = (service) => {
    setSelectedService(service);
    setIsModalOpen(true);
    document.body.style.overflow = 'hidden';
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setSelectedService(null);
    document.body.style.overflow = 'auto';
  }

  const handleModalOverlayClick = (e) => {
    if (e.target.classList.contains('modal-overlay')) {
      closeModal();
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setAnimatedElements((prev) => ({ ...prev, courses: true }));
          }
        });
      },
      { threshold: 0.1 }
    );
    const section = document.getElementById('courses');
    if (section) observer.observe(section);
    return () => {
      if (section) observer.unobserve(section);
      // observer.disconnect(); // Consider if this causes issues if observer is used elsewhere or if component re-renders often
    }
  }, []);

  useEffect(() => {
    const container = coursesContainerRef.current;
    if (!container) return;
    const checkScroll = () => {
      const { scrollLeft, scrollWidth, clientWidth } = container;
      setCanScrollRight(scrollLeft + clientWidth < scrollWidth - 5);
    };
    checkScroll();
    container.addEventListener('scroll', checkScroll);
    window.addEventListener('resize', checkScroll);
    return () => {
      container.removeEventListener('scroll', checkScroll);
      window.removeEventListener('resize', checkScroll);
    };
  }, []);

  const totalPages = Math.max(1, Math.ceil(courseData.length / cardsPerView));

  return (
    <section id="courses" className="courses-section animate-on-scroll" style={{
      padding: '6rem 2rem',
      textAlign: 'center',
      background: 'linear-gradient(180deg, rgba(255,250,240,0.7) 0%, rgba(248,250,245,0.9) 100%)',
      position: 'relative',
    }}>
      <h2 className="section-title" style={{
        fontSize: '2rem',
        fontFamily: '"Noto Serif TC","Microsoft JhengHei", "PingFang TC", serif',
        fontWeight: 600,
        color: colors.primary,
        animation: animatedElements['courses'] ? 'fadeInUp 1s ease forwards' : 'none',
        opacity: animatedElements['courses'] ? 1 : 0,
      }}>
        課程介紹
        <div style={{
          width: '500px', height: '2px', background: 'linear-gradient(90deg, #5C8989, rgba(92, 137, 137, 0.3))',
          margin: '0.5rem auto 2rem', borderRadius: '1px', position: 'relative', overflow: 'hidden'
        }}>
          <div style={{
            position: 'absolute', top: 0, left: '-100%', width: '50%', height: '100%',
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.5), transparent)',
            animation: 'shine 3s infinite'
          }} />
        </div>
      </h2>

      <p style={{
        fontSize: '1.1rem', color: colors.neutralLight, maxWidth: '600px', margin: '0 auto 3rem',
        lineHeight: '1.6', fontWeight: 600,
        animation: animatedElements['courses'] ? 'fadeIn 1.2s ease 0.3s forwards' : 'none',
        opacity: animatedElements['courses'] ? 1 : 0
      }}>
        專業的療程與技術，為您帶來身心靈的全面放鬆與煥新
      </p>

      <div style={{ position: 'relative', maxWidth: '900px', margin: '0 auto' }}>
        {totalPages > 1 && (
          <>
            <button onClick={handlePrevClick} disabled={currentPage === 0} style={{
              position: 'absolute', left: '-20px', top: '50%', transform: 'translateY(-50%)',
              width: '40px', height: '40px', borderRadius: '50%', background: colors.secondary,
              color: 'white', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 3px 10px rgba(76, 149, 108, 0.3)', cursor: currentPage === 0 ? 'not-allowed' : 'pointer',
              zIndex: 10,
              opacity: currentPage === 0 ? 0.3 : 1,
              transition: 'opacity 0.3s ease, background-color 0.3s ease'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
              </svg>
            </button>

            <button onClick={handleNextClick} disabled={currentPage >= totalPages - 1 || !canScrollRight} style={{
              position: 'absolute', right: '-20px', top: '50%', transform: 'translateY(-50%)',
              width: '40px', height: '40px', borderRadius: '50%', background: colors.secondary,
              color: 'white', border: 'none', display: 'flex', alignItems: 'center', justifyContent: 'center',
              boxShadow: '0 3px 10px rgba(76, 149, 108, 0.3)', cursor: (currentPage >= totalPages - 1 || !canScrollRight) ? 'not-allowed' : 'pointer',
              zIndex: 10,
              opacity: (currentPage >= totalPages - 1 || !canScrollRight) ? 0.3 : 1,
              transition: 'opacity 0.3s ease, background-color 0.3s ease'
            }}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            </button>
          </>
        )}

        <div ref={coursesContainerRef} style={{
          display: 'flex', overflowX: 'auto', scrollBehavior: 'smooth',
          padding: '20px 0px', margin: '0',
          msOverflowStyle: 'none', scrollbarWidth: 'none',
          WebkitOverflowScrolling: 'touch',
        }}>
          {courseData.map((service) => (
            <div key={service.id} className="service-card" style={{
              flex: '0 0 280px', margin: '0 10px', borderRadius: '12px',
              overflow: 'hidden', backgroundColor: 'rgba(255, 255, 255, 0.85)',
              textAlign: 'left', boxShadow: '0 8px 20px rgba(0,0,0,0.08)',
              transition: 'all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)',
              display: 'flex', flexDirection: 'column',
            }}>
              <img src={`/assets/img/${service.img}`} alt={service.title} style={{ width: '100%', height: '200px', objectFit: 'cover' }} />
              <div style={{ padding: '1.2rem', flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
                <div style={{ fontSize: '0.85rem', color: colors.secondary, marginBottom: '0.2rem', fontWeight: 600 }}>{service.desc}</div>
                <div style={{
                  fontSize: '1.3rem', fontWeight: 'bold', color: colors.primary, marginBottom: '0.5rem', fontFamily: '"Noto Serif TC","Microsoft JhengHei", "PingFang TC", serif',
                }}>{service.title}</div>
                <p style={{
                  fontSize: '0.9rem', color: colors.textDark, lineHeight: '1.5',
                  height: '63px', overflow: 'hidden', textOverflow: 'ellipsis',
                  display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical',
                  marginBottom: '1rem',
                }}>{service.content}</p>
                <div style={{ marginTop: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span style={{ fontSize: '1.1rem', fontWeight: 'bold', color: colors.secondary }}>{service.price || '洽詢'}</span>
                  <button onClick={() => handleCourseDetail(service)} style={{
                    padding: '0.6rem 1.2rem', background: colors.primary, color: 'white',
                    border: 'none', borderRadius: '6px', fontSize: '0.85rem',
                    fontWeight: 500, cursor: 'pointer', transition: 'background-color 0.3s ease'
                  }}>
                    了解詳情
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Modal - Updated Structure */}
      {isModalOpen && selectedService && (
        <div
          className="modal-overlay"
          onClick={handleModalOverlayClick}
          style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            background: 'rgba(0, 0, 0, 0.65)', display: 'flex',
            justifyContent: 'center', alignItems: 'center',
            zIndex: 1000, backdropFilter: 'blur(5px)',
            animation: 'fadeInModalOverlay 0.3s forwards' // Assuming CSS animation defined
          }}
        >
          <div
            className="modal-content-container"
            style={{
              background: colors.cream, borderRadius: '12px',
              maxWidth: '700px', // Increased width for more content
              width: '90%',
              boxShadow: '0 10px 30px rgba(0,0,0,0.15)',
              maxHeight: '90vh', // Increased height
              display: 'flex', flexDirection: 'column',
              animation: 'slideInModalContent 0.4s 0.1s forwards cubic-bezier(0.25, 0.46, 0.45, 0.94)' // Assuming CSS animation defined
            }}
          >
            {/* Modal Header */}
            <div style={{
              padding: '1.5rem 2rem',
              borderBottom: `1px solid ${colors.accent}`,
              textAlign: 'center'
            }}>
              <h3 style={{
                fontSize: '2rem', // Larger title
                color: colors.primary, marginBottom: '0.5rem',
                fontFamily: "'Cormorant Garamond', serif", fontWeight: 600
              }}>
                {selectedService.title}
              </h3>
              <p style={{ fontSize: '1rem', color: colors.secondary, fontWeight: 500 }}>
                {selectedService.desc}
              </p>
            </div>

            {/* Modal Body - Scrollable */}
            <div style={{ padding: '1rem 0.5rem', overflowY: 'auto', flexGrow: 1, background: colors.light }}>
              {/* Main Category Introduction Text */}
              <p style={{
                fontSize: '1rem', color: colors.textDark, lineHeight: '1.7',
                padding: '0.5rem 1.5rem 1.5rem 1.5rem', // Add padding around intro text
                textAlign: 'justify',
                borderBottom: `1px dashed ${colors.accent}`,
                marginBottom: '1rem'
              }}>
                {selectedService.content}
              </p>

              {/* Sub-Courses List */}
              {selectedService.details && selectedService.details.length > 0 && (
                <div style={{ padding: '0 1.5rem' }}> {/* Padding for sub-course items container */}
                  {selectedService.details.map((subItem) => {
                    const text = subItem.subTitle;
                    const firstAscii = text.search(/[A-Za-z]/);
                    // 找到首個英文字母在字串裡的 index，如果沒有會回傳 -1

                    let titleZh, titleEn;

                    if (firstAscii > 0) {
                      titleZh = text.slice(0, firstAscii).trim();
                      titleEn = text.slice(firstAscii).trim();
                    } else {
                      titleZh = text;
                      titleEn = '';
                    }


                    return (
                      <div key={subItem.subId} className="sub-course-item" style={{
                        background: colors.cream, // Slightly different background for each item card
                        borderRadius: '8px',
                        padding: '1.5rem',
                        marginBottom: '1.5rem',
                        boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
                        display: 'flex', // Use flex for image and text alignment
                        gap: '1.5rem', // Space between image and text content
                        alignItems: 'center', // Align items to the top
                      }}>
                        {/* Sub-Course Image */}
                        <img
                          src={`/assets/img/${subItem.subImage}`}
                          alt={subItem.subTitle}
                          style={{

                            width: '200px', // Fixed width for sub-item image
                            height: '230px', // Fixed height
                            objectFit: 'cover',
                            borderRadius: '6px',
                            flexShrink: 0, // Prevent image from shrinking
                          }}
                        />

                        {/* Sub-Course Content */}
                        <div style={{ flexGrow: 1 }}>
                          <h4 style={{
                            fontSize: '1.4rem',
                            color: colors.primary,
                            fontFamily: "'Noto Serif TC','Cormorant Garamond', serif",
                            fontWeight: 600,
                            lineHeight: 1.4,
                            whiteSpace: 'normal',    // 允許自動換行
                          }}>
                            <span style={{
                              display: 'block',      // 中方標題前後獨立成行
                            }}>
                              {titleZh}
                            </span>

                            {titleEn && (
                              <span style={{
                                display: 'block',      // 英文獨立成行
                                fontSize: '1.2rem',
                                color: colors.primary,
                                fontFamily: "'Cormorant Garamond', serif",
                                fontWeight: 500,
                                letterSpacing: '1px',
                                marginTop: '0.3rem',   // 中英文間距
                                whiteSpace: 'pre-wrap' // 保留空格換行
                              }}>
                                {titleEn}
                              </span>
                            )}
                          </h4>


                          <p style={{ fontSize: '1.1rem', color: colors.secondary, fontWeight: 'bold', marginBottom: '0.75rem' }}>
                            {subItem.subPrice}
                          </p>
                          <p style={{ fontSize: '0.95rem', color: colors.textDark, lineHeight: '1.6', marginBottom: '1rem', textAlign: 'left' }}>
                            {subItem.subDescription}
                          </p>
                          {subItem.subFeatures && subItem.subFeatures.length > 0 && (
                            <ul style={{ listStyle: 'none', paddingLeft: '0', fontSize: '0.9rem', color: colors.neutralLight }}>
                              {subItem.subFeatures.map((feature, index) => (
                                <li key={index} style={{ marginBottom: '0.3rem', paddingLeft: '1.2rem', position: 'relative', textAlign: 'left' }}>
                                  <span style={{
                                    position: 'absolute', left: 0, top: '7px', width: '5px', height: '5px',
                                    borderRadius: '50%', backgroundColor: colors.secondary
                                  }}></span>
                                  {feature}
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    );
                  })}

                </div>
              )}
            </div>

            {/* Modal Footer */}
            <div style={{
              padding: '1.5rem 2rem',
              borderTop: `1px solid ${colors.accent}`,
              textAlign: 'right',
              background: colors.cream // Match header background
            }}>
              <button onClick={closeModal} style={{
                padding: '0.75rem 1.8rem', background: colors.secondary,
                color: '#fff', border: 'none', borderRadius: '6px',
                cursor: 'pointer', fontSize: '0.9rem', fontWeight: 500,
                transition: 'background-color 0.3s ease, transform 0.2s ease'
              }}>
                關閉
              </button>
            </div>
          </div>
        </div>

      )}
      <>



      </>



    </section>
  );
}